import { WizardPageTemplateWithTitle } from 'gw-portals-wizard-react';
import FNOLAdditionalInformationPage from 'gw-capability-fnol-common-react/pages/AdditionalInformation/AdditionalInformationPage';
import { messages as commonMessages } from 'gw-platform-translations';
import SasriaFNOLSummaryPage from '../Summary/SasriaFNOLSummaryPage';
import SasriaAddBank from '../Bank/SasriaAddBank';

const bankDetailsStep = {
    id: 'bankDetails',
    path: '/bankDetails',
    component: SasriaAddBank,
    stepProps: {
        template: WizardPageTemplateWithTitle
    },
    title: commonMessages.expressClaimBankDetails
};

const documentsStep = {
    id: 'document',
    path: '/document',
    component: FNOLAdditionalInformationPage,
    stepProps: {
        template: WizardPageTemplateWithTitle
    },
    title: commonMessages.expressClaimDocument
};

const summaryStep = {
    id: 'summary',
    path: '/summary',
    component: SasriaFNOLSummaryPage,
    stepProps: {
        template: WizardPageTemplateWithTitle
    },
    title: commonMessages.expressClaimSummary
};

export {
    documentsStep,
    bankDetailsStep,
    summaryStep
};
